
import React from 'react'
import { ContentCopy} from "@mui/icons-material"
import {CustomTooltip} from  '../customtooltip/CustomTooltip'
import StatusContext from '../../../contexts/StatusContext'
import CopyWithTimeout from './CopyWithTimeout';

import "./customicons.css"

export const CopyTextIcon = ({ prompt }) => {
  let {
    isLoading,
    changeLanguage,
    isTextCopied,
    onCopy,
} = React.useContext(StatusContext); 

  return (
   
    <div>
       {
          ( !isTextCopied.status || isTextCopied.id !== prompt.id) && 
              <>
              <div>
                <CustomTooltip title={changeLanguage('status', 'copy')}>
                  <ContentCopy
                    className="promptCopyIcon"
                    onClick={() => {
                      !isLoading && onCopy(prompt);
                    }}
                  />
                </CustomTooltip>
              </div>
              </>
        }  
        {
          (isTextCopied.id === prompt.id && isTextCopied.status) && 
              <CopyWithTimeout />
        }
    </div> 

  )
}
  




